/**
 * This is for nice displaying of seconds to text
 * IMPORTANT:
 * - input needs to be in fractions of the day, so if you have seconds, it needs to be = s / 86400
 */
export const EXPORT_NICE_TIME_FORMAT = '[h]:mm:ss';

export const secondsToDayFractionForExport = (s: number): number => s / 86400;

export const EXPORT_NUMBER_FORMAT = '#,##0';
